// Color names from https://colornamer.robertcooper.me/

export const Colors = {
  ArmorWash: '#030303',
  ArmorWashTransLucent: 'rgba(3, 3, 3, 0.5)',
  AtlanticCharter: '#2C2D40',
  Black: '#000000',
  BlackVelvet: '#202237',
  Blood: '#780202',
  BlueTitmouse: '#3E5FFF',
  ChannelMarkerGreen: '#00DBB6',
  ChefsHat: '#F2F4F7',
  Comet: '#636474',
  CoralCommander: '#F06666',
  CreamyCaramel: '#B2966B',
  DarkRed: '#C50011',
  DeepAtlanticBlue: '#014D59',
  DarkRift: '#08081B',
  ElectricRed: '#E60000',
  ExplosiveGrey: '#C4C4C4',
  FadedLilac: '#8EA2BE',
  FallGold: '#FBBF39',
  FlannelPajamas: '#8A8D9C',
  FragrantCloves: '#AA5E3C',
  GoldFusion: '#EB9700',
  GrainOfSalt: '#D8DBE0',
  GramsHair: '#F5F6F7',
  HarlocksCape: '#BD0000',
  HeartBeat: '#AA0000',
  IrisBlue: '#00B0CA',
  JacarandaLight: '#A8ACB8',
  JackO: '#F89300',
  JadeShard: '#007C92',
  LapOfLuxury: '#525365',
  LaRioja: '#B7BF10',
  LilacHint: '#C9CCD4',
  LynxWhite: '#F7F7F7',
  Metro: '#808392',
  MidnightExpress: '#222739',
  MountainFig: '#393949',
  MountainFigTranslucent: 'rgba(57, 57, 73, 0.5)',
  MughalGreen: '#428600',
  NotTonight: '#08081B',
  OldMillBlue: '#6D6F81',
  PaparazziFlash: '#C7CCD0',
  PicnicDaySky: '#00D0EF',
  PicoOrange: '#FFA300',
  PurpleInk: '#9C2AA0',
  RavenBlack: '#3D3D3D',
  RiverTour: '#878B98',
  Sambucus: '#141827',
  SilverSurfer: '#7D7E89',
  ShadowGargoyle: '#676767',
  SpandexGreen: '#38B64F',
  SpanishGrey: '#979797',
  SpearShaft: '#875803',
  SpringGreen: '#A8B400',
  SpectrumRed: '#F50000',
  StatusGreen: '#90B400',
  TheWildApothecary: '#108846',
  ThickPurple: '#8442DB',
  Transparent: '#00000000',
  TransparentDark: '#00000059',
  TrustMeThisIsGreen: '#AA0000',
  White: '#FFFFFF',
  ArtisansGold: '#EB9701',
  IslamicGreen: '#009900',
  DarkBlue: '#047082',
  DarkGreen: '#377000'
};
